const AdditionalProductsIcon = ({ color = "#303030" }: { color?: string }) => {
    return (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.7583 7.10874L11.6333 4.04627C11.5171 3.98808 11.3813 3.98458 11.2625 4.03686L4.2625 7.09934C4.10303 7.1689 4 7.32618 4 7.50009V14.5C4 14.6658 4.09362 14.8172 4.24172 14.8914L10.3667 17.9538C10.4284 17.9847 10.4953 18 10.5625 18C10.6222 18 10.6817 17.9878 10.7377 17.9633L17.7377 14.9008C17.897 14.8312 18 14.6739 18 14.5V7.50009C18 7.33427 17.9064 7.1829 17.7583 7.10874ZM11.425 4.92061L16.5315 7.47384L14.0752 8.54855L8.96869 5.99532L11.425 4.92061ZM10.125 16.8546L4.875 14.2297V8.20795L10.125 10.8329V16.8546ZM10.575 10.0796L5.46869 7.52655L7.92503 6.45184L13.0313 9.00507L10.575 10.0796ZM17.125 14.2141L11 16.8936V10.8487L13.625 9.70025V12.75C13.625 12.9915 13.8208 13.1875 14.0625 13.1875C14.3042 13.1875 14.5 12.9915 14.5 12.75V9.31745L17.125 8.16902V14.2141Z"
                fill={color}
            />
        </svg>
    );
};

export default AdditionalProductsIcon;
